import styled from "styled-components";
import { breakpoints } from "../../../../utils/responsive_utilities";
import { fontQuicksand } from "../../mixin";

export const Input = styled.input`
  background: transparent;
  box-sizing: border-box;
  border: 0;
  border-bottom: ${props => !props.isError ? `1px solid #4F52C3` : `1px solid #FC6161` };
  border-radius: 0;
  display: block;
  padding: 0.6rem 0rem 0.6rem 0.6rem;
  width: 100%;
  ${fontQuicksand(1.6, 2.0, 7)}
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  ::placeholder {
    color: #313575;
  }
  @media screen and (max-width: ${breakpoints.sm}px) {
    font-size: 1.2rem;
  }
`;

export const InputLabel = styled.div`
  color: #9294F6;
  text-transform: uppercase;
  letter-spacing: 2px;
  ${fontQuicksand(1.2, 1.44)}
  text-align: left;
  margin-top: 12px;
  @media screen and (max-width: ${breakpoints.sm}px) {
    font-size: 10px;
  }
`;

export const Error = styled.div`
  color: #FC6161;
  font-family: "Quicksand", 'Helvetica','Arial','sans-serif';
  font-size: 12px;
  font-weight: 500;
  text-align: left;
  @media screen and (max-width: ${breakpoints.sm}px) {
    font-size: 10px;
  }
`;
